<template>
  <v-container fluid class="py-0">
    <v-row >
      <v-col cols=12 class="d-flex justify-end py-0">
        <ImportAutos formTitle="IMPORTAR AUTOS" @import="importDatos" />
      </v-col>
      <v-col cols=12 class="my-0 pt-2 pb-2"><v-divider /></v-col>
      
      <v-col cols=12 sm=6 lg=4>                        
        <v-select
          :items="marcas_autos"
          v-model="frm.marca"
          label="Marca"
          placeholder="Seleccione una marca de auto"
          ref="marca"
          append-icon="fa fa-angle-down "
          class="caption"
          menu-props="auto"
         
          append-outer-icon="fa-refresh"
          @click:append-outer="loadMarcas()"
          @change="loadModelos()"
          dense
          hide-details
          return-object
          clearable
        />
      </v-col>
      <v-col cols=12 sm=6 lg=4 >          
        <v-select
          :items="modelos_autos"
          v-model="frm.modelo"
          label="Modelo"
          placeholder="Seleccione un modelo de auto"
          ref="modelo"
          append-icon="fa fa-angle-down "
          class="caption"
          menu-props="auto"
          dense
          hide-details
          return-object
          clearable
        />
      </v-col>
      <v-col cols=6 sm=4 lg=2>            
        <v-text-field
          v-model="frm.fDesde" 
          label="Fecha Desde" 
          placeholder="mm/aaaa"  
          dense 
          hide-details 
          class="caption" 
        />
      </v-col>
      <v-col cols=6 sm=4 lg=2>
        <v-text-field 
          v-model="frm.fHasta"
          label="Fecha Hasta" 
          placeholder="mm/aaaa"
          dense 
          hide-details 
          class="caption" 
        />
      </v-col>
      <v-col cols=12 sm=4 lg=4>
          <v-select
          :items="text_autos"
          v-model="frm.eje"
          label="Eje"
          append-icon="fa fa-angle-down "
          class="caption"
          menu-props="auto"
          dense
          hide-details
          return-object
          clearable
        />
      </v-col>
      <v-col cols=10 sm=6  >
        <v-text-field 
          v-model="frm.obs"
          label="Observación" 
          placeholder="Ingrese un texto"  
          dense 
          hide-details 
          class="caption" 
        />
      </v-col>
      <v-col cols=1 class="text-center"  >
        <v-btn ref="add" x-small class="my-auto mx-0"	fab color="primary"	
          :disabled="!(frm.marca && frm.marca.value)"
          @click="addItems"
        >
          <v-icon dense>fa fa-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="px-0">
      <v-col cols=12 >
        <v-data-table
          dense
          :headers="headers"
          :items="Items"
          class="elevation-2"
          :hide-default-header="false"
          min-height="200px"
          height="300px"
          :fixed-header="true"
          :items-per-page="999"
          hide-default-footer
          :disable-pagination='false'
          :loading="loadGrid"
        
          :mobile-breakpoint=100
        >


          <template v-slot:item="{item,isSelected,select,headers} ">
            <tr >
              <template v-for="(h, idx) in headers" >
                <td v-if="h.value!='actions'" :align="h.align" :key="idx" :class="['caption', h.class]" v-text="item[h.value]" />
                <td v-else :align="h.align" :key="idx" :class="[ h.class]" class="px-1">
                  <v-icon
                    small
                    class="mx-3"
                    @click="editItem(item)"
                  >
                    fa fa-pencil
                  </v-icon>
                  <v-icon
                    small
                    class="mx-3"
                    @click="removeItem(item)"
                  >
                    fa fa-trash-o
                  </v-icon>
                </td>
              </template> 
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
  import {mapGetters} from 'vuex'
  import ImportAutos from '@/components/Commond/ImportAutos'

  export default {
    name: 'Autos',
    props:['items'],

    components: {
      ImportAutos
    },

    data: () => ({
      loadGrid:false,

      headers: [
        { text: 'Marca',align: 'start',sortable: true, value: 'marca_text' },
        { text: 'Modelo' ,align: 'start',sortable: true, value: 'modelo_text'},
        { text: 'Obs' ,align: 'start',sortable: true, value: 'obs'},
        { text: 'Eje', align:'start',sortable:true,value:'eje_text'},
        { text: 'F. Desde' ,align: 'start',sortable: false, value: 'fDesde'},
        { text: 'F. Hasta' ,align: 'start',sortable: false, value: 'fHasta'},
        { text: ''       ,align: 'center'  ,sortable: false, value: 'actions', width:"85px" },
      ],
      editedIndex: -1,
      editedItem :{

      },

      default:{
        id:0,
        marca:{},
        modelo:{},
        fDesde:"",
        fHasta:"",
        eje:{},
        obs:""
      },

      frm:{
        id:0,
        marca:{},
        modelo:{},
        fDesde:"",
        fHasta:"",
        eje:{},
        obs:""
      },

      marcas_autos:[],
      modelos_autos:[],
      text_autos:[],

    }),
    created: function () {
      console.log("Componente creado")
      console.log(this.items)
      this.initialize()
    },
    mounted: function () {
      console.log("Componente mondado")
    },
    watch: {
    },

    methods: {

      importDatos (val) {
        //console.log("IMPORT-->",val)
        this.items.push(...val)
        //console.log(this.items)
        
      },
      async loadModelos (){
        this.modelos_autos=[]

        if (this.frm.marca && this.frm.marca.value>0){
          let response
          let opt={
            method: 'GET', 
            mode: 'cors'
          }
          response = await fetch(`${this.ROOT_API}autos/modelos?_filters={"marcaID":${this.frm.marca.value}}`, opt);
          if (response.ok){
            let r=await response.json()
            this.modelos_autos=r.map(item => {
              return {
                value:item.id,
                text:item.descripcion 
              }
            })
          }

        }
      },
      async loadMarcas () {
        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }

        //INI MARCAS AUTOS
        
        response = await fetch(`${this.ROOT_API}autos/marcas`, opt);
        if (response.ok){
          let r=await response.json()
          this.marcas_autos=r.map(item => {
            return {
              value:item.id,
              text:item.descripcion 
            }
          })
        }
        //FIN MARCAS AUTOS

      },
      async initialize () {

        this.loadMarcas()

        let response
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        


        //INI EJE AUTOS
        response = await fetch(`${this.ROOT_API}text_autos`, opt);
        if (response.ok){
          let r=await response.json()
          this.text_autos=r.map(item => {
            return {
              value:item.id,
              text:item.eje.toUpperCase()
            }
          })
        }
        //FIN EJE AUTOS
        
      },

      editItem (item){
        this.editedIndex = this.items.indexOf(item)
        this.editedItem=Object.assign({}, item)

        
        
        this.frm={
          id: item.id, 
          marca:  item.marca_value?{value:item.marca_value,text:item.marca_text}:{}, 
          modelo: item.modelo_value?{value:item.modelo_value,text:item.modelo_text}:{}, 
          fDesde: item.fDesde, 
          fHasta: item.fHasta, 
          eje:    item.eje_value?{value:item.eje_value,text:item.eje_text}:{}, 
          obs:    item.obs
        
        }

        this.loadModelos()
      },

      addItems (){
        if (this.editedIndex==-1){
          console.log("nuevo item")
          this.items.push({
            id: 0,
            marca_value:this.frm.marca ? this.frm.marca.value : null, 
            marca_text :this.frm.marca ? this.frm.marca.text : "", 
            modelo_value:this.frm.modelo ? this.frm.modelo.value : null, 
            modelo_text :this.frm.modelo ? this.frm.modelo.text : "", 
            fDesde: this.frm.fDesde,
            fHasta: this.frm.fHasta,
            eje_value: this.frm.eje? this.frm.eje.value : 0,
            eje_text : this.frm.eje? this.frm.eje.text  : "" ,
            obs:this.frm.obs, 
            accion:"I"
          })
        }
        else {
          console.log("edit item")
          this.editedItem.marca_value=this.frm.marca ? this.frm.marca.value : null
          this.editedItem.marca_text =this.frm.marca ? this.frm.marca.text : ""
          this.editedItem.modelo_value=this.frm.modelo ? this.frm.modelo.value : null
          this.editedItem.modelo_text =this.frm.modelo ? this.frm.modelo.text : "" 
          this.editedItem.fDesde= this.frm.fDesde
          this.editedItem.fHasta= this.frm.fHasta
          this.editedItem.eje_value= this.frm.eje? this.frm.eje.value : 0
          this.editedItem.eje_text = this.frm.eje? this.frm.eje.text  : ""
          this.editedItem.obs=this.frm.obs 
          
          this.editedItem.accion==this.frm.id?"U":"I"


          Object.assign(this.items[this.editedIndex],this.editedItem)
        }

        
        this.frm=Object.assign({},this.default)
        this.editedItem={}
        this.editedIndex=-1
      },

      removeItem (item) {
        if (confirm('Seguro que desea eliminar el item seleccionado?')){
          let index = this.items.indexOf(item)
          console.log("index --> ",index)

          if (item.id!=0){
            console.log("DELETE LOGICO")
            item.accion="D"
            //this.editedIndex = this.items.indexOf(item)
            this.items[index]=Object.assign({}, item)
          }
          else {
            console.log("DELETE")
            this.items.splice(index,1)
          }
        }
      },

      send () {
        //this.frm=Object.assign({},this.default)
        /*
        console.log("PASAJE DE PARAMETROS AL PADRE ",this.items)
        this.items.push({
          codigo: "NUEVO",
          marca_text: "NUEVA MACAR",
          marca_value: 2

        })
        this.$emit('send',this.items)
        */
      },

    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      Items () {
        let r
        r=this.items.filter( item => item.accion!="D")
        return r
      },

    },
  }
</script>

<style scoped>

</style>
